// extracted by mini-css-extract-plugin
module.exports = {"selectAvvenimento":"ScommesseTipoEsitiUnderThree_selectAvvenimento__zuJNQ","boxAvvenimento":"ScommesseTipoEsitiUnderThree_boxAvvenimento____859"};